import React, {Component} from 'react';
import CheckBox from '../checkbox';

class InputPrice extends Component {
  constructor(props){
    super(props);

    this.handlePrevOnChange = this.handlePrevOnChange.bind(this);
    this.handleNextOnChange = this.handleNextOnChange.bind(this);
  }

  
  handlePrevOnChange(e){
    const {handlePrevOnChange} = this.props;
    handlePrevOnChange(e.target.value);
  }

  handleNextOnChange(e){
    const {handleNextOnChange} = this.props;
    handleNextOnChange(e.target.value);
  }
  render() {
    const {
      prevPrice,
      nextPrice,
      prevPriceChk,
      nextPriceChk,

      onPrevPriceCheck,
      onNextPriceCheck
    } = this.props;

    
    return (
      <div className='input-container'>
        <CheckBox id="prevPrice_checkbox"
          handleOnClick={onPrevPriceCheck}
          checked={prevPriceChk}
        />
        <input className='prev-price element' 
          onInput={this.handlePrevOnChange}
          disabled={!prevPriceChk}
          value={prevPrice}
        />
        <span className="prev-label">만원</span>
        ~
        <CheckBox id="nextPrice_checkbox"
          handleOnClick={onNextPriceCheck}
          checked={nextPriceChk}
        />
        <input className='next-price element' 
          onInput={this.handleNextOnChange}
          disabled={!nextPriceChk}
          value={nextPrice}
        />
        <span className="next-label">만원</span>
      </div>
    );
  }
}

export default InputPrice;


// WEBPACK FOOTER //
// ./src/components/input/price.js